import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { promStringify } from '../../../shared/utils/prometheus';

const useStyles = makeStyles({
  timeseries: {
    wordBreak: 'break-all',
  },
});

interface TimeseriesExpressionProps {
  name: string;
  labels: string;
}

const TimeseriesExpression: React.FC<TimeseriesExpressionProps> = ({ name, labels }: TimeseriesExpressionProps) => {
  const classes = useStyles();

  const labelsJson = JSON.parse(labels) as Record<string, string>;
  return (
    <span className={classes.timeseries}>
      <b>{name}</b>
      {`${promStringify(labelsJson)}`}
    </span>
  );
};

export default TimeseriesExpression;
